// extracted by mini-css-extract-plugin
export default {"error":"PortalPage__error--17o","content":"PortalPage__content--3rT"};